function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGuidebookOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.167 5.246c2.66-1.247 7.034-2.325 11.41.761a1 1 0 01.423.818V27a1 1 0 01-1.576.817c-2.959-2.087-5.896-2.089-8.133-1.563a12.457 12.457 0 00-2.724.994 10.644 10.644 0 00-.942.536l-.022.015-.02.014-.007.004a1 1 0 01-1.15.001h-.002l-.007-.005a10.644 10.644 0 00-.984-.565c-.659-.332-1.6-.73-2.724-.994-2.237-.526-5.174-.524-8.133 1.563A1 1 0 012 27V6.825a1 1 0 01.424-.818c3.581-2.526 7.184-2.263 9.826-1.393a14.74 14.74 0 014.054 2.098 9.218 9.218 0 01.312.241l.02.017.006.005.003.002c0 .001.001.001-.645.765l.646-.764a1 1 0 01.354.764v15.512h-2V8.235a12.74 12.74 0 00-3.375-1.722C9.5 5.815 6.774 5.604 4 7.359v17.87c3.003-1.53 5.92-1.45 8.166-.92A14.46 14.46 0 0116 25.821a14.46 14.46 0 013.834-1.515c2.246-.528 5.163-.608 8.166.922V7.359c-3.406-2.154-6.768-1.349-8.996-.298l-.837-1.815z",
    fill: props.color
  }));
}

export default SvgIconGuidebookOutline;